import { FC } from 'react'
import clsx from 'clsx'
import { CorTriagem, tokenDoRisco } from './riscoTriagem'
import styles from './TriagemRiscoBadge.module.css'

type Props = {
  cor?: CorTriagem | string | null
  /**
   * O que a cor representa, para o nome acessível ("Cor do motor: Vermelho"). Passe o texto
   * traduzido (`triagem.rotulo.*`); o padrão é o rótulo de `triagem.rotulo.risco`.
   */
  titulo?: string
  /** Mostra também a prioridade por extenso ("Emergência"), além do nome da cor. */
  comPrioridade?: boolean
  className?: string
}

/**
 * Selo de risco no padrão do StatusBadge (TableCells), em cor sólida: cor + nome por extenso +
 * forma (BRAND.md), nunca só a cor. Sem cor não renderiza nada — quem usa decide o vazio (ex.: o
 * `—` com rótulo do RiscoTriagemCell).
 */
export const TriagemRiscoBadge: FC<Props> = ({
  cor,
  titulo = 'Classificação de risco',
  comPrioridade,
  className,
}) => {
  const token = tokenDoRisco(cor)
  if (!token) {
    return null
  }
  const rotulo = comPrioridade ? `${token.nome} — ${token.prioridade}` : token.nome
  return (
    <span
      className={clsx(styles.badge, styles[token.tom], className)}
      aria-label={`${titulo}: ${rotulo}`}
    >
      <i className={clsx('bi', token.icone, styles.icone)} aria-hidden='true' />
      {rotulo}
    </span>
  )
}
